import { render } from "./PanoramaVariant.vue?vue&type=template&id=10b02498"
import script from "./PanoramaVariant.vue?vue&type=script&lang=js"
export * from "./PanoramaVariant.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__